import React from 'react';

// Custom slider styled with cyan->purple gradient track
const GradientSlider = ({ value, min = 0, max = 100, step = 1, onChange, marks = [] }) => {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className="w-full">
      <div className="relative h-6 flex items-center">
        <div
          className="absolute inset-x-0 h-[3px] rounded-full"
          style={{
            background:
              'linear-gradient(90deg, #22d3ee 0%, #a855f7 100%)',
            opacity: 0.9,
          }}
        />
        <div
          className="absolute h-[3px] rounded-full bg-white/10"
          style={{ left: `${pct}%`, right: 0 }}
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value, 10))}
          className="gradient-range absolute inset-0 w-full appearance-none bg-transparent cursor-pointer"
          style={{ '--pct': `${pct}%` }}
        />
      </div>
      {marks.length > 0 && (
        <div className="mt-2 flex justify-between text-[11px] text-white/40">
          {marks.map((m, i) => (
            <span key={i}>{m}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default GradientSlider;
